import { useEffect, useState } from "react";
import { API_URL } from "../../config";
import { Link } from "react-router-dom";

import classes from "./Chats.module.css";

function Users({ user }) {
  const [users, setUsers] = useState([]);

  const [isWorking, setIsWorking] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsWorking(true);
    setError(null);
    fetch(API_URL + "api/messages/users", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + user.token,
      },
    })
      .then((response) => {
        if (!response.ok)
          setError({
            message: `(${response.status}) ${response.statusText} ${
              response.ok ? "OK" : "NOT OK"
            }`,
          });
        else return response.json();
      })
      .then((data) => {
        setUsers(data);
      })
      .catch((err) => {
        setError({ message: "Can't fetch users. See console" });
        console.log(err);
      })
      .finally(() => setIsWorking(false));
  }, [user.token]);

  // return (
  //   <>
  //     {isWorking && <div>Loading...</div>}
  //     {error && <div>Errror: {error.message}</div>}
  //     {users && users.length ? (
  //       <ul className={classes.list}>
  //         {users.map((user) => (

  //             <Link key={user.id} to={"/chats/" + user.id}>{user.username}</Link>

  //         ))}
  //       </ul>
  //     ) : (
  //       <div>No users found</div>
  //     )}
  //   </>
  // );

  return (
    <div className={classes.chats}>
      <div className={classes.title}>
        <span>Send New Message</span>
      </div>
      {isWorking || error ? (
        <div className={classes.info}>
          {isWorking && <div>Loading...</div>}
          {error && <div>Errror: {error.message}</div>}
        </div>
      ) : (
        <div className={classes.actions}>
          {/* <Link to={"users"}>Send new message</Link> */}
        </div>
      )}

      {users && users.length ? (
        <ul className={classes.list}>
          {users.map((user) => (
            <Link key={user.id} to={"/chats/" + user.id}>
              {user.username}
            </Link>
          ))}
        </ul>
      ) : (
        <div className={classes.list}>
          <span>No users found</span>
        </div>
      )}
    </div>
  );
}

export default Users;
